namespace Matrix.Data {

    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class PartyRelationshipsDialog extends Serenity.TemplatedDialog<any> {

        public grid: PartyRelationshipGrid;

        constructor() {
            super();

            this.grid = new PartyRelationshipGrid(this.element.children());
        }

        protected getTemplate() {
            return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}